export { MatPaginatorNoTotalDisplayed } from './no-total-displayed';
